﻿var jquery = require("jquery");
var HabEvents = require("../../Global/habitaclia-events");
var trackLeadSubmission = require("./lead-tracking");

(function () {
	"use strict";
	/* Àlex. TODO: Mirar qué casos nos faltan y añadir en el Enum (librería solicitudes) */
	const __ERROR_TYPE = {
		"ParsedResponse" : "errorParsearASP",
		"NoSession" : "sinSession",
		"FormDataError" : "errorFormulario",
		"BlackList": "errorBlackList",
		"SpamIndex": "spamIndex",
		"AjaxCallError": "errorLlamadaAjax",
		"AjaxResponseError" : "ajaxResponseError",
		"PotentialMassiveAttack": "potentialMassiveAttack",
		"NoError" : ""
	};

	/*jshint unused:false*/
	var LeadTrace = function() {

	};

	var __error = function(oSolicitudViewModel, errorType) {
        var reasons = {errorFormulario: 'DATA_ERROR', errorBlackList: 'SPAM_ERROR', spamIndex: 'SPAM_ERROR', potentialMassiveAttack: 'MASSIVE_ATTACK_ERROR', sinSession: 'CAPTCHA_REQUIRED', errorLlamadaAjax: 'NETWORK_ERROR', ajaxResponseError: 'NETWORK_ERROR'};
        trackLeadSubmission('failed', reasons[errorType] || 'UNKNOWN_ERROR');
		oSolicitudViewModel.MotivoError = errorType;
		jquery.publish(HabEvents.EventsEnum.UrlAjaxSolicitudError);
	};

	LeadTrace.prototype = {
		constructor: LeadTrace,
		Error: __error,
		ErrorType: __ERROR_TYPE
	};

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = new LeadTrace();
	} else {
		window.LeadTrace = LeadTrace;
	}

}());